import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '../views/Dashboard.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: '/',
    component: Dashboard
  },
  {
    path: '/nosotros',
    name: 'Nostros',
    component: () => import('../views/Nosotros.vue')
  },
  {
    path: '/agencias',
    name: 'Agencias',
    component: () => import('../views/Agencias.vue')
  },
  {
    path: '/directorio',
    name: 'Directorio',
    component: () => import('../views/Directorio.vue')
  },
  {
    path: '/contactenos',
    name: 'Contactenos',
    component: () => import('../views/Contactenos.vue')
  },
  {
    path: '/mesapartevirtual',
    name: 'MesaParteVirtual',
    component: () => import('../views/MesaParteVirtual.vue')
  },
  {
    path: '/boletas_electronicas',
    name: 'BoletasElectronicas',
    component: () => import('../views/BoletasElectronicas.vue')
  },
  {
    path: '/noticias',
    name: 'Noticias',
    component: () => import('../views/Noticias.vue')
  },
  {
    path: '/noticia/:id',
    name: 'Noticia',
    component: () => import('../views/Noticia.vue')
  },
  {
    path: '/convocatorias',
    name: 'Convocatorias',
    component: () => import('../views/Convocatorias.vue')
  },
  {
    path: '/convocatoria/:id',
    name: 'Convocatoria',
    component: () => import('../views/Convocatoria.vue')
  },

  {
    path: '/precios_productos',
    name: 'Precios_productos',
    component: () => import('../views/Precios_productos.vue')
  },
  {
    path: '/complementarios',
    name: 'Complementarios',
    component: () => import('../views/Complementarios.vue')
  },
  {
    path: '/costo_produccion',
    name: 'Costo_produccion',
    component: () => import('../views/Costo_produccion.vue')
  },
  {
    path: '/bolsa_productos',
    name: 'Bolsa_productos',
    component: () => import('../views/Bolsa_productos.vue')
  },
  {
    path: '/reporte_plagas',
    name: 'Reporte_plagas',
    component: () => import('../views/Reporte_plagas.vue')
  },
  {
    path: '/agricola_pecuaria',
    name: 'Agricola_pecuaria',
    component: () => import('../views/Agricola_pecuaria.vue')
  },

  {
    path: '/convocatorias_nombramiento',
    name: 'Convocatorias_nombramiento',
    component: () => import('../views/Convocatorias_nombramiento.vue')
  },
  {
    path: '/convocatoria_nombramiento/:id',
    name: 'Convocatoria_nombramiento',
    component: () => import('../views/Convocatoria_nombramiento.vue')
  },
  {
    path: '/convenios',
    name: 'Convenios',
    component: () => import('../views/Convenios.vue')
  },
  {
    path: '/documentos_gestion',
    name: 'Documentos_gestion',
    component: () => import('../views/Documentos_gestion.vue')
  },
  {
    path: '/resoluciones',
    name: 'Resoluciones',
    component: () => import('../views/Resoluciones.vue')
  },
  {
    path: '/sci',
    name: 'Sci',
    component: () => import('../views/Sci.vue')
  },
  {
    path: '/fideicomiso',
    name: 'Fideicomiso',
    component: () => import('../views/Fideicomiso.vue')
  },
  {
    path: '/organigrama',
    name: 'Organigrama',
    component: () => import('../views/Organigrama.vue')
  },
  {
    path: '/acceso_informacion',
    name: 'Acceso_informacion',
    component: () => import('../views/Acceso_informacion.vue')
  },
  /*
  {
    path: '/reporte_visitas',
    name: 'Reporte_visitas',
    component: () => import('../views/Reporte_visitas.vue')
  },
  {
    path: '/agenda_titular',
    name: 'AgendaTitular',
    component: () => import('../views/AgendaTitular.vue')
  },
  {
    path: '/agenda_alta_direccion',
    name: 'AgendaAltaDireccion',
    component: () => import('../views/AgendaAltaDireccion.vue')
  },
  */
  {
    path: '/procesador_observatorio',
    name: 'ProcesadorObservatorio',
    component: () => import('../views/ProcesadorObservatorio.vue')
  },
  
  {
    path: "*",
    name: "NotFound",
    property: {},
    children: [],
   component: () => import('../views/Error404.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
